import { FormGroup, FormGroupProps, Truncate } from "@patternfly/react-core";

interface FormGroupTruncatedProps {
    /** Label text before the field. Will be truncated with a tooltip if too long. */
    label: string,
}

/**
 * Patternfly FormGroup with truncated label.
 */
const FormGroupTruncated = (props: React.PropsWithChildren<FormGroupTruncatedProps & FormGroupProps>) => {
    const { label, children, ...rest } = props;

    return (
        <FormGroup
            label={<div><Truncate content={label}></Truncate></div>}
            {...rest}
            >
            {children}
        </FormGroup>
    );
}

export default FormGroupTruncated;
